import React, { useEffect, useState } from "react"
import { styled, keyframes } from "../stitches.config"
import axios from "axios"
import Slider from "react-slick"
import { format, isBefore, isThisWeek, isToday, isTomorrow, isPast } from "date-fns"
import { pl } from "date-fns/locale"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Link from "./Link"
import { useBreakpoint } from "../helpers/useBreakpoint"
//#4571
const blink = keyframes({
    from: {
        opacity: 0
    },
    "50%": {
        opacity: 1
    },
    to: {
        opacity: 0
    }
});

const FootballScores = ({ data }) => {
    const isMobile = useBreakpoint();
    const isDesktop = window.innerWidth >= 996;

    const [scores, setScores] = useState(data);

    useEffect(() => {
        let fetchTimeout;

        const getScores = async () => {
            try {
                const { data } = await axios.get(`${window.API_HOST}/api/sport-results`);
                setScores(data);
            } catch { }
            fetchTimeout = setTimeout(() => getScores(), 10000);
        };
        getScores();

        return () => clearTimeout(fetchTimeout);
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1310,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    }

    const formatDate = (date) => {
        if (isToday(new Date(date))) {
            return "Dziś"
        } else if (isTomorrow(new Date(date))) {
            return "Jutro"
        } else if (isPast(new Date(date))) {
            return format(new Date(date), "dd MMM", {
                locale: pl
            })
        } else if (isThisWeek(new Date(date))) {
            return format(new Date(date), "EE", {
                locale: pl
            })
        } else {
            return format(new Date(date), "dd MMM", {
                locale: pl
            })
        }
    };

    return <Wrap>
        <InfoContainer className="wc-2022-match-info-container">
            <Header>{isDesktop ? "Euro 2024" : "Terminy i wyniki meczów na Euro 2024"}</Header>
            <Info>Terminy i wyniki</Info>
            {isDesktop ? <Button to="/c/6,sport">Czytaj więcej</Button> : null}
        </InfoContainer>
        <Scores className="wc-2022-scores">
            <Slider {...settings}>
                {scores?.map((item, i) => <MatchContainer key={i}>
                    <MatchGroup className="wc-2022-match-group">{item.group}: {item.statusID == -1 && <span></span>}</MatchGroup>
                    <MatchBody className="wc-2022-match-body">
                        <ScoreWrap>
                            <img src={item.home.logo} />
                            <div>
                                <span>{item.home.name}</span>
                                <span> {item.statusID == 0 ? '-' : item.home_score}</span>
                            </div>
                        </ScoreWrap>
                        <ScoreWrap>
                            <img src={item.away.logo} />
                            <div>
                                <span>{item.away.name}</span>
                                <span> {item.statusID == 0 ? '-' : item.away_score}</span>
                            </div>
                        </ScoreWrap>
                    </MatchBody>
                    <MatchDate>{formatDate(item.date)}, {item.time}</MatchDate>
                </MatchContainer>)}
            </Slider>
        </Scores>
        {!isDesktop ? <Button to="/c/6,sport">Czytaj więcej</Button> : null}
    </Wrap>
}

const Wrap = styled("div", {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0",
    margin: "20px",
    borderBottom: "2px solid",
    borderColor: "$primary",
    minHeight: "236px",
    "@bp4": {
        minHeight: "148px",
        border: "none",
        flexDirection: "row",
        margin: "0"
    }
});

const InfoContainer = styled("div", {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginBottom: "20px",
    color: "$grayscale100",
    "@bp4": {
        width: "140px",
        marginBottom: "0px",
        marginRight: "40px",
        height: "auto"
    }
});

const Header = styled("div", {
    fontFamily: "$grotesk",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});


const Info = styled("p", {
    display: "none",
    "@bp4": {
        display: "initial",
        fontSize: "17px",
        fontWeight: 600,
        textAlign: "center",
        margin: "10px 0"
    }
});

const Button = styled(Link, {
    display: "block",
    backgroundColor: "$primary",
    textAlign: "center",
    padding: "5px 10px",
    fontSize: "13px",
    margin: "20px auto 0 auto",
    "@bp4": {
        padding: "5px 10px",
        width: "115px",
        height: "27px",
        fontSize: "13px",
        margin: "0"
    }
});

const Scores = styled("div", {
    marginTop: "5px",
    ".slick-arrow": {
        addingTop: "2px",
        "&:before": {
            opacity: 1,
            color: "$grayscale100"
        }
    },
    ".slick-next": {
        right: "-15px"
    },
    "@bp4": {
        width: "calc(100% - 200px)"
    },
});

const MatchContainer = styled("div", {
    maxWidth: "100px",
    height: "100px",
    p: {
        color: "#606060",
        margin: "0",
        fontSize: "12px",
        marginTop: "5px"
    },
    "@bp4": {
        maxWidth: "117px",
        borderRight: "1px solid #dbdbdb",
        paddingRight: "10px"
    }
});

const MatchGroup = styled("div", {
    display: "flex",
    fontFamily: "HK Grotesk",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    marginBottom: "6px",
    color: "$grayscale100",
    "&>span": {
        marginLeft: "auto",
        "&:before": {
            content: "",
            display: "inline-block",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "red",
            animation: `${blink} 1s linear infinite`
        }
    }
});

const MatchBody = styled("div", {
    color: "$grayscale100"
});

const MatchDate = styled("p", {
    color: "$grayscale90 !important"
});

const ScoreWrap = styled("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    img: {
        height: "28px",
        width: "28px"
    },
    "&>div": {
        marginLeft: "5px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        span: {
            display: "block",
            fontWeight: 500,
            fontSize: "11px"
        }
    }
});

export default FootballScores
